
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1538_5298)","stroke":"#7D1E36","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M15 9.25V6.333c0-.353-.134-.692-.373-.942a1.244 1.244 0 00-.9-.391h-2.545L9.909 3H6.091L4.818 5H2.273c-.338 0-.662.14-.9.39-.239.25-.373.59-.373.943v7.334c0 .353.134.692.373.943.238.25.562.39.9.39h7.36","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.786 13.603h4.793M15.182 11.207V16"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1538_5298"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    